import React from "react";
import PropTypes from "prop-types";
import { makeStyles } from '@mui/styles';
import LayoutContext from "../LayoutContext";
import { hasValue } from "../../../utils/utils";

const EDITOR_LAYOUT_DEFAULT_LABEL_WIDTH = 200;
const EDITOR_LAYOUT_DEFAULT_LINE_HEIGHT = "25px";

/**
 *
 * @param {Object} params
 * @param {number} params.labelWidth
 * @param {(number|string)} params.labelHeight
 * @param {Object} params.style
 */
function EditorLayout({ labelWidth, lineHeight, style, children }) {
  const classes = useStyles({
    lineHeight: hasValue(lineHeight)
      ? lineHeight
      : EDITOR_LAYOUT_DEFAULT_LINE_HEIGHT,
  });

  return (
    <LayoutContext.Provider
      value={{
        labelWidth: hasValue(labelWidth)
          ? labelWidth
          : EDITOR_LAYOUT_DEFAULT_LABEL_WIDTH,
      }}
    >
      <div className={classes.root} style={style}>
        {children}
      </div>
    </LayoutContext.Provider>
  );
}

const useStyles = makeStyles({
  root: (props) => ({
    lineHeight: props.lineHeight,
    paddingLeft: "20px",
    paddingRight: "40px",
    paddingBottom: "30px",
  }),
});

EditorLayout.propTypes = {
  labelWidth: PropTypes.number,
  lineHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  children: PropTypes.node,
  style: PropTypes.object,
};

export default EditorLayout;

